import { useInfiniteQuery } from '@tanstack/react-query'
import {
	type HttpGetGeosParams,
	httpGetGeos
} from '@/features/subgeo/http/get-geos.http'
import { infiniteQueryFetchNextPage } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetGeos = (
	promiseArgs?: Partial<
		Omit<HttpGetGeosParams, 'page' | 'responseType' | 'limit'>
	>,
	options?: { enabled?: boolean }
) => {
	const params = {
		responseType: 'small' as const,
		limit: 50,
		...promiseArgs
	}

	const query = useInfiniteQuery({
		queryKey: [QUERY_KEYS.GET_GEOS, params],
		queryFn: ({ pageParam = 1 }) =>
			httpGetGeos({ ...params, page: pageParam }),
		enabled: options?.enabled,
		initialPageParam: 1,
		getNextPageParam: ({ meta }) =>
			meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null
	})

	return {
		...query,
		fetchNextPage: () => infiniteQueryFetchNextPage(query),
		remappedData: query.data?.pages[0]?.data?.length
			? query.data.pages.flatMap((page) => page.data)
			: []
	}
}
